import "./Channel.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Form, Input, message, Pagination, Row, Spin } from "antd";
import moment from "moment";

import Swal from "sweetalert2";

import inquiryApi from "../../apis/Inquiry.api";
import { loginAlert, toastAlert } from "../../components/AlertComponent";
import { setLoading } from "../../redux/store/common/commonDuck";

const InquiryBoard = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	const pageSize = 10;
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [totalCount, setTotalCount] = useState(0);

	const [findInquiry, setFindInquiry] = useState(false);
	const [sessionFind, setSessionFind] = useState(true);
	const inquiryFind = sessionStorage?.getItem("inquiry-find");

	const [inquiryList, setInquiryList] = useState([]);

	// useEffect(() => {
	//     if (!sessionFind) {
	//         setSessionFind(true);
	//     }
	// }, [history])

	useEffect(() => {
		if (inquiryFind) {
			if (inquiryFind === "true" && !findInquiry) {
				setFindInquiry(true);
			}
			if (inquiryFind === "false" && !!findInquiry) {
				setFindInquiry(false);
			}
			setSessionFind(false);
		}
	}, [history, findInquiry, inquiryFind, sessionFind]);

	useEffect(() => {
		if (!cUser?.id && reduxChannel?.influencer_id) {
			getInquiryList();
			setFindInquiry(false);
			// setCurrentPageNumber(1);
			sessionStorage.setItem("inquiry-find", "false");
		}
	}, [cUser, reduxChannel]);

	useEffect(() => {
		if (reduxChannel?.influencer_id && cUser?.id && !sessionFind) {
			if (findInquiry) {
				getFindInquiryList();
			} else {
				getInquiryList();
			}
		}
	}, [reduxChannel, cUser, currentPageNumber, findInquiry, sessionFind]);

	/**
	 * page 넘김
	 */
	const handleChangePagination = async (pageNumber) => {
		const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
	};

	/**
	 * 각 상담게시글로 이동
	 * @param item
	 */
	const moveInquiryEachPage = (item) => {
		if (item?.id) {
			if (!item?.is_secret || !!item?.is_mine) {
				history.push(
					`/together/channel/inquiry/${item.id}?id=${reduxChannel?.influencer_id}`
				);
			} else {
				toastAlert("비밀글은 본인이 작성한 글만 확인할 수 있습니다.");
			}
		}
	};

	/**
	 * 상담게시글 목록 조회
	 * @returns {Promise<void>}
	 */
	const getInquiryList = async () => {
		const param = {
			offset: (currentPageNumber - 1) * pageSize,
			pageSize: pageSize,
			influencerId: reduxChannel?.user_id,
			userId: cUser?.id ?? 0,
		};

		console.log(param);
		setIsLoading(true);
		const res = await inquiryApi.readInquiryList(param);

		if (res.code === 200) {
			setTotalCount(res.result?.totalCnt);
			setInquiryList(res.result?.inquiryList);
			setIsLoading(false);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("get-inquiry-list-error");
				setIsLoading(false);
			});
		}
	};

	/**
	 * 내가 쓴 글 보기
	 * @returns {Promise<void>}
	 */
	const getFindInquiryList = async () => {
		const param = {
			offset: (currentPageNumber - 1) * pageSize,
			pageSize: pageSize,
			influencerId: reduxChannel?.user_id,
			userId: cUser?.id ?? 0,
		};

		setIsLoading(true);
		const res = await inquiryApi.findInquiryList(param);
		if (res.code === 200) {
			setTotalCount(res.result?.totalCnt);
			setInquiryList(res.result?.inquiryList);
			setIsLoading(false);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				setIsLoading(false);
			});
		}
	};

	const loginValidation = () => {
		if (!cUser?.id) {
			loginAlert({ history, reduxChannel });
		}
	};

	return (
		<div className="channel-home">
			<div className={`home-body`}>
				<div className={`max-width-apply`}>
					<div className={`inquiry-board-banner`}>
						<h2>궁금했던 이야기!</h2>
						<h1>약사님에게 직접 물어보세요!</h1>
						<p>
							평소 오징어약사tv를 보며 궁금했던 영양제, 약, 당뇨, 건강 이야기에
							대해 자유롭게 남겨보세요!
						</p>
						<p>
							늦더라도 최선을 다해서 순차적으로 답변드릴테니 양해부탁드립니다 :)
						</p>
						<p className={`gray`}>
							*비방, 비하, 욕설, 사적인 내용의 이야기 등의 게시물은 모니터링에
							의해 자동으로 삭제됨을 알려드립니다.
						</p>
					</div>
					<div className={`inquiry-board-title`}>
						<p>추천 상담 게시판</p>
						<div className={`inquiry-board-button-group`}>
							<Button
								className={`${findInquiry ? "find-access" : ""}`}
								disabled={isLoading}
								onClick={() => {
									loginValidation();
									if (cUser?.id) {
										if (!findInquiry) {
											setFindInquiry(true);
											setCurrentPageNumber(1);
											sessionStorage.setItem("inquiry-find", "true");
										} else {
											setFindInquiry(false);
											setCurrentPageNumber(1);
											sessionStorage.setItem("inquiry-find", "false");
										}
									}
								}}
							>
								내가 쓴 글 보기
							</Button>
							<Button
								disabled={isLoading}
								className={`black`}
								onClick={() => {
									loginValidation();
									if (cUser?.id) {
										history.push(
											`/together/channel/inquiry/board/update/new?id=${reduxChannel?.influencer_id}`
										);
									}
								}}
							>
								상담 글쓰기
							</Button>
						</div>
					</div>
					<div className={`inquiry-board-table`}>
						<div className={`inquiry-board-table-title`}>
							<p className={`table-1`}>답변 상태</p>
							<p className={`table-2`}>문의 사항</p>
							<p className={`table-3`}>작성자</p>
							<p className={`table-4`}>작성일</p>
						</div>

						{inquiryList?.length ? (
							<>
								{!mediaResult ? (
									// PC
									<>
										{inquiryList?.map((item, idx) => (
											<div
												className={`inquiry-board-table-content`}
												key={`inquiry-table-${idx}`}
											>
												<p className={`table-1`}>
													<span
														className={`${
															item?.is_answer ? "answer-success" : "answer-yet"
														}`}
													>
														{item?.is_answer ? "답변완료" : "답변예정"}
													</span>
												</p>
												<p
													className={`table-2`}
													onClick={() => moveInquiryEachPage(item)}
												>
													{item?.is_secret ? (
														<>
															<img
																src={`/assets/images/channel/secret-black.png`}
																alt={`비밀댓글`}
																style={{
																	width: "0.9em",
																	height: "auto",
																}}
															/>
															비밀글입니다.
														</>
													) : (
														<>{item?.title}</>
													)}
												</p>
												<p className={`table-3`}>{item?.created_by_name}</p>
												<p className={`table-4`}>
													{moment(item?.created_at).format("YYYY.MM.DD")}
												</p>
											</div>
										))}
									</>
								) : (
									// mobile
									<>
										{inquiryList?.map((item, idx) => (
											<div
												className={`inquiry-board-table-content-mobile`}
												key={`inquiry-table-mobile-${idx}`}
											>
												<div className={`inquiry-board-table-title-mobile`}>
													<p
														className={`${
															item?.is_answer ? "answer-success" : "answer-yet"
														}`}
													>
														{item?.is_answer ? "답변완료" : "답변예정"}
													</p>
													<p
														className={`inquiry-content-mobile`}
														onClick={() => moveInquiryEachPage(item)}
													>
														{item?.is_secret ? (
															<>
																<img
																	src={`/assets/images/channel/secret-black.png`}
																	alt={`비밀댓글`}
																	style={{
																		width: "0.9em",
																		height: "auto",
																	}}
																/>
																비밀글입니다.
															</>
														) : (
															<>{item?.title}</>
														)}
													</p>
												</div>
												<div className={`inquiry-board-table-create-mobile`}>
													<p>{item?.created_by_name}</p>
													<p>|</p>
													<p>{moment(item?.created_at).format("YYYY.MM.DD")}</p>
												</div>
											</div>
										))}
									</>
								)}
							</>
						) : (
							<Row
								align={"middle"}
								style={{
									width: "100%",
									flexDirection: "column",
									padding: "3em 0",
								}}
							>
								<img
									src={`/assets/images/warning.png`}
									alt={`warning-icon`}
									style={{
										width: "3.5em",
										height: "auto",
									}}
								/>
								<span
									style={{
										marginTop: "1em",
										color: "#adb5bd",
										fontSize: "1.2em",
										fontWeight: 500,
									}}
								>
									일치하는 내용이 없습니다.
								</span>
							</Row>
						)}
					</div>

					{!!inquiryList?.length && (
						<Pagination
							className="report-pagination-wrap"
							showSizeChanger={false}
							current={currentPageNumber}
							pageSize={pageSize}
							total={totalCount}
							onChange={handleChangePagination}
							disabled={isLoading}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
export default InquiryBoard;
